<section class="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0 p-4">
  <div class="paginator-report">
    {{ 'DASHBOARD.DOCUMENTS SPACE.SHOWING' | translate }}
    <span>
      {{ getDisplayedItemsRange.start }}
    </span>

    {{ 'DASHBOARD.DOCUMENTS SPACE.TO' | translate }}
    <span>
      {{ getDisplayedItemsRange.end }}
    </span>
    {{ 'DASHBOARD.DOCUMENTS SPACE.OF' | translate }}
    <span>
      {{ totalItems }}
    </span>
    {{ 'DASHBOARD.DOCUMENTS SPACE.ENTRIES' | translate }}
  </div>

  <div class="paginator">
    <ul>
      <li>
        <button (click)="goToPreviousPage()" [disabled]="currentPage === 0" class="paginator-button rounded-s-lg">
          <span class="sr-only">Previous</span>
          <app-system-icon iconName="chevron-left" iconType="outline" [iconSize]="32"></app-system-icon>
        </button>
      </li>
      <li *ngFor="let page of pageNumbers; trackBy: trackByFn">
        <button
          [ngClass]="{ 'active-button': currentPage + 1 === page }"
          class="paginator-button"
          [disabled]="currentPage + 1 === page"
          (click)="goToPage(page - 1)"
        >
          {{ page }}
        </button>
      </li>
      <li>
        <button
          (click)="goToNextPage()"
          [disabled]="currentPage + 1 === totalPages"
          class="paginator-button rounded-e-lg"
        >
          <span class="sr-only">Previous</span>
          <app-system-icon iconName="chevron-right" iconType="outline" [iconSize]="32"></app-system-icon>
        </button>
      </li>
    </ul>
  </div>
</section>
